<template>
  <div class="col mt-3">
    <!-- exit -->

    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-3 m-3 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Exit Spells"
          position="right"
        >
          <img
            :src="exitImg"
            @click="exitHandler()"
            height="48"
            width="48"
            alt="exit image"
          />
        </ToolTip>
      </button>
    </div>

    <!-- add spell -->

    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        @click="showSpellPanelHandler()"
      >
        <ToolTip
          text="Add Spell"
          position="right"
        >
          <i
            class="bi bi-plus"
            style="color: white; font-size: 5em"
          ></i>
        </ToolTip>
      </button>
    </div>
  </div>
</template>

<script>
import ToolTip from '../components/ToolTip.vue'
import exitImg from '../assets/images/bbExit100.png'
//==========================================================
// scripts
//---------
export default {
  name: 'SpellStaticButtonsPanel',
  emits: ['show-spell-static-panel'],
  components: {
    ToolTip,
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      exitImg,
    }
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //--------------
    // exit handler
    //--------------
    exitHandler() {
      this.emitter.emit('exit-spell-static-view')
    },
    //--------------------------
    // show spell panel handler
    //--------------------------
    showSpellPanelHandler() {
      this.$emit('show-spell-static-panel')
    },
  },
}
</script>
